import { Accordion, HStack, Icon, useAccordionItemContext } from '@chakra-ui/react';
import * as React from 'react';
import { LuChevronDown, LuMinus, LuPlus } from 'react-icons/lu';

type IndicatorSymbol = 'chevron' | 'plus';
interface AccordionItemTriggerProps extends Accordion.ItemTriggerProps {
  indicatorPlacement?: 'start' | 'end';
  startRotation?: number;
  endRotation?: number;
  indicator?: IndicatorSymbol;
}
const PlusMinusIndicator = () => {
  const { expanded } = useAccordionItemContext();
  return <Icon color="brandIndigo">{expanded ? <LuMinus /> : <LuPlus />}</Icon>;
};

export const AccordionItemIndicator = ({
  indicator,
  startRotation,
  endRotation,
}: {
  indicator?: IndicatorSymbol;
  startRotation?: number;
  endRotation?: number;
}) => {
  if (indicator === 'plus') {
    const startDegrees = `${startRotation ?? -90}deg`;
    const endDegrees = `${endRotation ?? 0}deg`;
    return (
      <Accordion.ItemIndicator rotate={{ base: startDegrees, _open: endDegrees }}>
        <PlusMinusIndicator />
      </Accordion.ItemIndicator>
    );
  }
  const startDegrees = `${startRotation ?? 0}deg`;
  const endDegrees = `${endRotation ?? 180}deg`;
  return (
    <Accordion.ItemIndicator rotate={{ base: startDegrees, _open: endDegrees }}>
      <LuChevronDown />
    </Accordion.ItemIndicator>
  );
};

export const AccordionItemTrigger = React.forwardRef<HTMLButtonElement, AccordionItemTriggerProps>(
  function AccordionItemTrigger(props, ref) {
    const { children, indicatorPlacement = 'end', indicator, startRotation, endRotation, ...rest } = props;

    return (
      <Accordion.ItemTrigger {...rest} ref={ref}>
        {indicatorPlacement === 'start' && (
          <AccordionItemIndicator indicator={indicator} startRotation={startRotation} endRotation={endRotation} />
        )}
        <HStack gap="4" flex="1" textAlign="start" width="full">
          {children}
        </HStack>
        {indicatorPlacement === 'end' && (
          <AccordionItemIndicator indicator={indicator} startRotation={startRotation} endRotation={endRotation} />
        )}
      </Accordion.ItemTrigger>
    );
  },
);

// This is just part of chakra ui component boilerplate. Ignore errors nothing to see here.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface AccordionItemContentProps extends Accordion.ItemContentProps {}

export const AccordionItemContent = React.forwardRef<HTMLDivElement, AccordionItemContentProps>(
  function AccordionItemContent(props, ref) {
    return (
      <Accordion.ItemContent>
        <Accordion.ItemBody {...props} ref={ref} />
      </Accordion.ItemContent>
    );
  },
);

export const AccordionRoot = Accordion.Root;
export const AccordionItem = Accordion.Item;
